import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "loading-container q-mt-sm" }
const _hoisted_2 = { class: "field-group__row no-wrap justify-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
      return _createElementVNode("div", {
        key: n,
        class: "field-group"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "skeleton skeleton-title" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["skeleton skeleton-text", {
            'skeleton-text-short': n % 3 === 0,
            'skeleton-text-medium': n % 3 === 1,
          }])
          }, null, 2)
        ])
      ])
    }), 64))
  ]))
}